import { Button } from "@/components/ui/button";
import { Link, useLocation } from "react-router";
import { Menu, X } from "lucide-react";
import { useState, useEffect } from "react";
import { SignedIn, SignedOut, UserButton } from "@clerk/clerk-react";

const NAV_LINKS = [
  { label: "Features", to: "/features/domain-lookup" },
  { label: "Use Cases", to: "/use-cases/saas-dashboards" },
  { label: "Compare", to: "/compare/clearbit" },
  { label: "API Docs", to: "/docs" },
  { label: "Pricing", to: "/#pricing" },
];

export function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav className="sticky top-0 z-50 border-b bg-background/85 backdrop-blur-md">
      <div className="max-w-[1120px] mx-auto px-6 flex items-center justify-between h-14">
        <Link to="/" className="flex items-center gap-2 font-extrabold text-lg tracking-tight text-foreground no-underline">
          <img src="/logo.svg" alt="LoadLogo" className="w-7 h-7" />
          LoadLogo
        </Link>
        <div className="hidden sm:flex items-center gap-1">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="text-sm font-medium text-secondary-foreground px-3 py-1.5 rounded-lg hover:bg-muted hover:text-foreground transition-colors no-underline"
            >
              {link.label}
            </Link>
          ))}
          <SignedOut>
            <Button size="sm" className="ml-2" asChild>
              <Link to="/sign-in">Sign In</Link>
            </Button>
          </SignedOut>
          <SignedIn>
            <Button size="sm" variant="outline" className="ml-2" asChild>
              <Link to="/dashboard">Dashboard</Link>
            </Button>
            <div className="ml-2">
              <UserButton afterSignOutUrl="/" />
            </div>
          </SignedIn>
        </div>

        {/* Mobile toggle */}
        <button
          className="sm:hidden p-2 -mr-2 text-muted-foreground hover:text-foreground"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="sm:hidden border-t bg-background px-6 py-4 space-y-1 animate-menu-in">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="block text-sm font-medium text-secondary-foreground py-2 hover:text-foreground transition-colors no-underline"
            >
              {link.label}
            </Link>
          ))}
          <div className="pt-2 space-y-2">
            <SignedOut>
              <Button size="sm" className="w-full" asChild>
                <Link to="/sign-in">Sign In</Link>
              </Button>
            </SignedOut>
            <SignedIn>
              <Button size="sm" variant="outline" className="w-full" asChild>
                <Link to="/dashboard">Dashboard</Link>
              </Button>
            </SignedIn>
          </div>
        </div>
      )}
    </nav>
  );
}
